import { Component } from '@angular/core';
import { COLUMNS_HEADER_CLEANING_RULES_ADMIN } from '../../core/constants/tables.constants';
import { faMagnifyingGlass, faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GenericTableComponent } from '../../components/generic-table/generic-table.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { CleaningMatrixService } from '../../core/services/cleaning-matrix.service';
import { CleaningsService } from '../../core/services/cleanings.service';
import { ProductsService } from '../../core/services/products.service';

@Component({
  selector: 'app-cleaning-rules',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule, GenericTableComponent, SpinnerComponent],
  templateUrl: './cleaning-rules.component.html',
  styleUrl: './cleaning-rules.component.scss'
})
export class CleaningRulesComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_CLEANING_RULES_ADMIN;

  cleaningMatrix: any;
  cleaningMatrixFiltered: any;
  products: any;
  cleanings: any;

  isModalActive = false;
  isLoading = false;
  isCreating = false;
  faMagnifyingGlass = faMagnifyingGlass;

  faSpinner = faSpinner;

  form: FormGroup = this.formBuilder.group({
    id: [, Validators.required],
    type: ['', Validators.required],
    lastProduct: ['', Validators.required],
    nextProduct: ['', Validators.required],
    min_time: ['', Validators.required],
    max_time: ['', Validators.required],
    name: ['', Validators.required],
  });

  filters: any = {
    search: {
      value: '',
      filter: (obj: any): boolean => {
        return ( obj.last_product?.toLowerCase().includes(this.filters.search.value.toLowerCase()) || obj.next_product?.toLowerCase().includes(this.filters.search.value) || obj.name?.toLowerCase().includes(this.filters.search.value.toLowerCase()) )
      }
    },
  };

  constructor(
    private cleaningMatrixSvc: CleaningMatrixService,
    private cleaningsSvc: CleaningsService,
    private productsSvc: ProductsService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getCleanings();
    this.getProducts();
    this.getCleaningMatrix();
  }

  onSave() {
    this.isLoading = true;
    const responseAction = {
      next: () => {
        this.getCleaningMatrix();
        this.isModalActive = false;
        this.isLoading = false;
        if (this.isCreating) {
          this.toastr.success(`La regla de limpieza ${this.form.value.id} ha sido creada correctamente`);
        } else {
          this.toastr.success(`La regla de limpieza ${this.form.value.id} ha sido actualizada correctamente`);
        }
        this.form.reset();
      },
      error: () => {
        this.isLoading = false;
      }
    };

    if (this.form.valid) {
      // if (this.isCreating) {
      //   this.cleaningRulesSvc.createCleaningRule(this.form.value).subscribe(responseAction);
      // } else {
      //   this.cleaningRulesSvc.updateCleaningRule(this.form.value).subscribe(responseAction);
      // }
    }

  }

  getCleaningMatrix() {
    this.cleaningMatrixSvc.getCleaningMatrix().subscribe((res: any) => {
      this.cleaningMatrix = [...res];
      this.cleaningMatrixFiltered = res;
      this.isLoading = false;
    });
  }

  getProducts() {
    this.products = this.productsSvc.getProducts();
  }

  getCleanings() {
    this.cleanings = this.cleaningsSvc.getCleanings();
  }

  getReactors() {
    // this.reactorsSvc.getReactors().subscribe(res => {
    //   this.reactors = res;
    // });
  }

  openModal(item?: any) {
    if (item) {
      this.form.patchValue(item);
      this.isCreating = false;
    } else {
      this.isCreating = true;
    }
    this.isModalActive = true;
  }

  closeModal() {
    this.isModalActive = false;
    this.form.reset();
    this.isCreating = false;
  }

  delete(item?: any) {
    this.isLoading = true
    // this.cleaningRulesSvc.deleteCleaningRule(item.id).subscribe({
    //   next: () => {
    //     this.getCleanings();
    //     this.getProducts();
    //     this.getReactors();
    //     this.getCleaningMatrix();
    //     this.isLoading = false;
    //     this.toastr.success(`La regla de limpieza ${item.id} ha sido eliminada correctamente`);
    //   },
    //   error: () => {
    //     this.isLoading = false
    //   }
    // });
  }

  onFilter() {
    this.cleaningMatrixFiltered = this.cleaningMatrix.filter((obj: any) => {
      return Object.keys(this.filters).map(f => {
        return !this.filters[f].value ? true : this.filters[f].filter(obj);
      }).filter(f => f).length === Object.keys(this.filters).length;
    });
  }

  resetFilters(keysSelected: any) {
    for (const key of Object.keys(this.filters)) {
      if (!keysSelected.includes(key)) {
          this.filters[key] = '';
      }
    }
  }


}
